/**
 * 表格骨架屏。
 *
 * 取代「表格中央一个转圈」：转圈只告诉用户「在等」，骨架屏还告诉他「等来的是
 * 一张几列的表格」，切换数据时不会整块闪烁成空白。
 *
 * 用 `animate-pulse` + 主题色令牌，明暗主题下都成立。
 */
const BARS = ['w-24', 'w-16', 'w-20', 'w-32', 'w-24', 'w-12']

export function TableSkeleton({ rows = 5, cols = 6 }: { rows?: number; cols?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={r} className="hover:bg-transparent">
          {Array.from({ length: cols }).map((__, c) => (
            <td key={c} className="px-3 py-3">
              <div
                className={`h-3 animate-pulse rounded bg-[var(--color-muted)] ${BARS[c % BARS.length]}`}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}
